<template>
  <div>
    <Dialog
      header="Duplicate Widgets"
      :visible.sync="duplicateWidgetForm1"
      :modal="true"
      class="p-fluid"
      :style="{ width: '500px', overflowY: 'auto' }"
    >
      <Message severity="info" :closable="false">
        Any existing Widget settings will be replaced with the new Widget
        Settings.</Message
      >
      <div class="p-formgrid p-grid" style="height: 22em;">
        <div class="p-field p-col">
          <label for="user"
            >Select the users you want to copy
            <strong>{{ user.fullName }}</strong> 's widgets to:</label
          >
          <MultiSelect
            v-model="users"
            :options="activeUsers"
            :filter="true"
            optionLabel="fullName"
            dataKey="id"
            placeholder="Select user's"
            :class="{ 'p-invalid': submitted && !(users && users.length) }"
          />
          <small class="p-invalid" v-if="submitted && !(users && users.length)"
            >Users are required.</small
          >
        </div>
      </div>

      <template #footer>
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-danger"
          style="width: 100px;"
          @click="$emit('close')"
        />
        <ProgressSpinner
          v-if="sendingRequest"
          style="width:25px; height:25px; width: 100px;"
          strokeWidth="5"
          fill="#EEEEEE"
          animationDuration=".5s"
        />
        <Button
          v-else
          label="Save"
          icon="pi pi-check"
          class="p-button-success"
          style="width: 100px;"
          @click="save"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import UserService from "@/service/UserService";

import { copyUserWidgetData } from "../sendRequest";

export default {
  created() {
    this.submitted = false;
    this.sendingRequest = false;
    this.users = [];

    this.userService
      .getAllActiveUsers()
      .then(data => {
        this.activeUsers = data;
      })
      .catch(e => {
        this.$store.dispatch("addErrorMessage", {
          severity: "error",
          content: 'Some data was not loaded from "activeUsers"'
        });
      });
  },
  props: {
    duplicateWidgetForm: {
      required: true,
      type: Boolean
    },
    user: {
      type: Object,
      required: false,
      default: () => {
        {
        }
      }
    }
  },
  data() {
    return {
      users: [],
      activeUsers: [],
      userService: new UserService(),
      submitted: false,
      sendingRequest: false
    };
  },
  computed: {
    duplicateWidgetFormKey: {
      set(val) {
        this.duplicateWidgetFormKey1++;
      },
      get() {
        return (
          "duplicateWidgetFormKey-" + this.duplicateWidgetFormKey1.toString()
        );
      }
    },
    duplicateWidgetForm1: {
      set(val) {
        if (!val) {
          this.$emit("close");
        }
      },
      get() {
        return this.duplicateWidgetForm;
      }
    }
  },
  watch: {
    duplicateWidgetForm(val) {
      this.duplicateWidgetFormKey = this.duplicateWidgetFormKey1 + 1;
    }
  },
  methods: {
    save() {
      this.submitted = true;
      this.sendingRequest = true;
      copyUserWidgetData(this, "DuplicateWidgetForm.vue");
    }
  }
};
</script>

<style scoped>
.row:hover {
  background-color: white;
}
</style>
